import React from "react";
import { RouteProps } from "react-router";

export interface RouteDefinition {
  path: string;
  exact?: boolean;
  requiresAuth?: boolean;
  layout: React.ComponentType<{ children: React.ReactNode }>;
  content: React.ComponentType;
  layoutProps?: Object;
}

interface EnhancedRouteProps {
  route: RouteDefinition;
}

export const EnhancedRoute = ({ route }: RouteProps & EnhancedRouteProps) => {
  let { layout: Layout, content: Content, layoutProps } = route;

  return (
    <Layout {...layoutProps}>
      <Content />
    </Layout>
  );
};
